import s from "./style.module.css";
import type { SidebarSection } from "../../types";
export interface Input {
    sections: SidebarSection[];
    activeId: string;
    onScroll: (e: Event) => void;
}
<const/{ sections, onScroll, activeId }=input>

<ul/linksRef class=s.links>
    <for|section| of=sections>
        <li>
            <a
                href=`${$global.url.pathname}#${section.id}`
                data-id=section.id
                data-active=`${section.id === activeId}`
                onClick(e) {
                    const target = document.getElementById(section.id);
                    if (target) {
                        e.preventDefault();
                        window.scrollTo({
                            top: target.offsetTop - 80,
                            left: 0,
                            behavior: "smooth",
                        });
                    }
                }>
                // ${section.title}
                <span>
                    <svg viewBox="0 0 16 16" width=16 height=16>
                        <path
                            d="M 2 8 L 14 8 L 8 2 M 14 8 L 8 14"
                            fill="none"
                            stroke="currentColor"
                            stroke-width=1.5
                            stroke-linecap="round"
                            stroke-linejoin="round"/>
                    </svg>
                    ${section.title}
                </span>
            </a>
        </li>
    </for>
</ul>
<script>
    linksRef().addEventListener("scroll", onScroll, {
        signal: $signal,
    });
</script>
